const footerColumns = [
  {
    title: "站内分区",
    links: [
      { href: "#hot", label: "热门全集榜" },
      { href: "#latenight", label: "深夜追番专区" },
      { href: "#classic", label: "经典老番补番" },
      { href: "#genre", label: "类型筛选" },
    ],
  },
  {
    title: "观看与下载",
    links: [
      { href: "#download", label: "下载清晰度说明" },
      { href: "#download", label: "整季打包合集" },
      { href: "#schedule", label: "每周更新表" },
      { href: "#guide", label: "新手使用指南" },
    ],
  },
  {
    title: "帮帮我",
    links: [
      { href: "#faq", label: "常见问题" },
      { href: "#stats", label: "站内数据一览" },
      { href: "#top", label: "回到顶部" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-accent-500 text-secondary-950 flex items-center justify-center">
                <i className="ri-movie-2-line text-xl" />
              </span>
              <span className="font-heading text-2xl text-background-50 tracking-wide">
                51动漫
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-100/70">
              一个把在线观看、离线下载与追番安排放到同一页的动漫资料入口。热门全集、深夜专区、经典老番分区并列，帮你更快找到想看的那一部，也更容易记住看到哪一集。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["热门全集", "深夜追番", "经典老番", "1080P 下载", "每周更新"].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-100/80"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-lg text-accent-400 tracking-wide">
                {col.title}
              </h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-100/70 transition-colors hover:text-background-50 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-background-50/10 pt-6">
          <p className="text-xs text-background-100/50">
            本站为演示性质的内容聚合页面，片库条目、评分与排期均为示例数据，不提供真实影片文件。
          </p>
          <p className="text-xs text-background-100/50 whitespace-nowrap">
            © 2026 51动漫 · 追番与补番的动漫资源入口
          </p>
        </div>
      </div>
    </footer>
  );
}